import { render, staticRenderFns } from "./CompanySave.vue?vue&type=template&id=ea2bf00c&scoped=true"
import script from "./CompanySave.vue?vue&type=script&lang=js"
export * from "./CompanySave.vue?vue&type=script&lang=js"
import style0 from "./CompanySave.vue?vue&type=style&index=0&id=ea2bf00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2bf00c",
  null
  
)

export default component.exports